import React from 'react'
import PropTypes from 'prop-types'
import Markdown from 'react-remarkable'

import './hero.scss'

const HeroSection = ({ image, description, title }) => {
  // const heroStyle = {
  //   backgroundImage: `url('${image}')`,
  //   backgroundSize: 'cover',
  // }
  return (
    <div className='hero-container'>
      <div className='hero-content'>
        {image && <img className='landing-image' src={image} alt='Olas arepas, auckland' />}
        <Markdown options={{ html: true }}>
          {description}
        </Markdown>
        <div className='social-bar'>
          <div>
            <a href='https://www.facebook.com/OlasArepas/' target='_blank' rel='noopener noreferrer'>
              <img src='/images/facebook.svg' alt='Olas Arepas Facebook' />
            </a>
            <a href='https://www.instagram.com/olasarepas/' target='_blank' rel='noopener noreferrer'>
              <img src='/images/instagram.svg' alt='Olas Arepas Instagram' />
            </a>
          </div>
          <a href='mailto:hi@olasarepas.co.nz'>hi@olasarepas.co.nz</a>
        </div>
      </div>
    </div>
  )
}

HeroSection.propTypes = {
  image: PropTypes.string,
  description: PropTypes.string,
  title: PropTypes.string,
}

export default HeroSection
